import { gql } from "@apollo/client";

const PRODUCT_FRAGMENT = gql`
	fragment terpeneFragment on Terpene {
		aliasList
		aromas
		description
		effects
		id
		name
		potentialHealthBenefits
		unitSymbol
	}

	fragment activeTerpeneFragment on ActiveTerpene {
		id
		terpene {
			...terpeneFragment
		}
		name
		terpeneId
		unit
		unitSymbol
		value
	}

	fragment activeCannabinoidFragment on ActiveCannabinoid {
		cannabinoidId
		cannabinoid {
			description
			id
			name
		}
		unit
		value
	}

	fragment productFragment on Product {
		brand {
			description
			id
			imageUrl
			name
		}
		category
		descriptionHtml
		effects
		enterpriseProductId
		id
		productBatchId
		images {
			id
			url
			label
			description
		}
		menuTypes
		name
		slug
		posId
		potencyCbd {
			formatted
			range
			unit
		}
		potencyThc {
			formatted
			range
			unit
		}
		posMetaData {
			id
			category
			sku
		}
		staffPick
		strainType
		subcategory
		tags
		variants {
			id
			option
			priceMed
			priceRec
			specialPriceMed
			specialPriceRec
			quantity
		}
		terpenes {
			...activeTerpeneFragment
		}
		cannabinoids {
			...activeCannabinoidFragment
		}
	}
`;
export default PRODUCT_FRAGMENT;
